
import React, { useState } from 'react'

export function useLocalStorage<T>(key: string, initialValue: T) {
  // State para armazenar nosso valor
  // Passa a função inicial de estado para useState para que a lógica seja executada apenas uma vez
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === "undefined") {
      return initialValue
    }
    try {
      // Pega do localStorage por chave
      const item = window.localStorage.getItem(key)
      // Parse JSON armazenado ou se none retorna initialValue
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      // Se erro também retorna initialValue
      console.log(error)
      return initialValue
    }
  })

  // Retorna uma versão wrapped da função setter do useState que ...
  // ... persiste o novo valor no localStorage.
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      // Permite que value seja uma função para que tenhamos a mesma API do useState
      const valueToStore = value instanceof Function ? value(storedValue) : value
      // Salva no state
      setStoredValue(valueToStore)
      // Salva no localStorage
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore))
      }
    } catch (error) {
      // Um casos mais avançados pode implementar logging de erros
      console.log(error)
    }
  }

  return [storedValue, setValue] as const
}
